import type { TFunction } from 'i18next';
import { array, number, string } from 'yup';

export const makeName = (t: TFunction) =>
  string()
    .required(t('onboarding.pleaseProvideName'))
    .min(2, t('onboarding.nameMustBeAtLeast'))
    .max(255, t('onboarding.nameTooLong')); // https://github.com/hoverinc/hyperion/blob/7e6672c38d1d32893e228416c411f4dbcc9849f4/db/schema.rb#L1969

export const makeEmail = (t: TFunction) =>
  string()
    .required(t('onboarding.emailIsRequired'))
    .email(t('onboarding.pleaseEnterAValidEmail'))
    .matches(
      /^[^@\s]+@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i,
      t('onboarding.pleaseEnterAValidEmail'),
    );

export enum OrgConstructionDescriptions {
  RESTORATION_AND_MITIGATION = 'restoration & mitigation',
  CONTRACTOR = 'contractor',
  CUSTOM_HOME_BUILDER = 'custom home builder (gc)',
  ARCHITECT_ENGINEER = 'architect / engineer',
  DESIGNER = 'designer',
  DISTRIBUTOR = 'distributor',
  MANUFACTURER = 'manufacturer',
}

export enum OrgInsuranceDescriptions {
  NATIONAL_CARRIER = 'national carrier',
  REGIONAL_CARRIER = 'regional carrier',
  FULL_SERVICE_ADJUSTING_FIRM = 'full service adjusting firm',
  THIRD_PARTY_LADDER_ASSIST_FIRM = '3rd party ladder assist firm',
  INDEPENDENT_ADJUSTER = 'independent adjuster',
  PUBLIC_ADJUSTING_FIRM = 'public adjusting firm',
  UNDERWRITING_INSPECTOR = 'underwriting inspector',
}
const validDescriptions = [
  ...Object.values(OrgConstructionDescriptions),
  ...Object.values(OrgInsuranceDescriptions),
];

export const makeOrgDescription = () =>
  array().required().of(string().required().oneOf(validDescriptions));

export const makeOrgUsageMin = () => number().positive().integer();
export const makeOrgUsageMax = () => number().positive().integer();
